import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService, WorkspaceService, HelperService } from "@mypxplat/xplat/core";
import { AppService, AvoService } from "@mypxplat/xplat/web/core";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-collaboration-invite-notice",
  templateUrl: "collaboration-invite-notice.component.html",
  standalone: false,
})
export class CollaborationInviteNoticeComponent extends BaseComponent {
  public loading: boolean;
  public invites: Array<any>;
  @Output() gotInvites: EventEmitter<any> = new EventEmitter();

  constructor(
    userService: UserService,
    public workspaceService: WorkspaceService,
    public translate: TranslateService,
    public router: Router,
    public appService: AppService,
    public avoService: AvoService,
    public helperService: HelperService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.init();
  }

  init(force?) {
    this.loading = true;
    this.workspaceService.getCollaborationInvites(force).subscribe((invites) => {
      this.gotInvites.next(invites);
      if (invites && invites.length) {
        this.invites = invites;
      } else {
        this.invites = [];
      }
    });
  }

  handle(accepted, invite) {
    let args = {
      id: invite.id,
      status: accepted ? "approved" : "rejected",
    };
    invite.loading = true;
    this.workspaceService.updateInvitation(args).subscribe((result) => {
      this.workspaceService.getCollaborationInvites(true).subscribe((result) => {
        this.workspaceService.getWorkspaces(true).subscribe((result) => {
          if (accepted) {
            this.router.navigate(["workspaces/detail", invite.workspace_id]);
            const page = this.avoService.getPageProperties({ pageName: "Workspace Detail" });
            const te = this.avoService.trackEvent();
            if (te && typeof te.workspaceViewed === "function") {
              const extra = {
                name: "Workspace Detail",
                workspaceId: parseInt(invite.workspace_id, 10),
                eventType: "invite",
                interactionType: "accepted",
              };
              const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
              te.workspaceViewed(payload);
            }
          } else {
            alert(this.translate.instant("sphere.workspaces.invitation_rejected"));
            const page = this.avoService.getPageProperties({ pageName: "Workspace Detail" });
            const te = this.avoService.trackEvent();
            if (te && typeof te.workspaceViewed === "function") {
              const extra = {
                name: "Workspace Detail",
                workspaceId: parseInt(invite.workspace_id, 10),
                eventType: "invite",
                interactionType: "rejected",
              };
              const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
              te.workspaceViewed(payload);
            }
          }
          this.init(true);
        });
      });
    });
  }
}
